import { Button } from "@mui/material";
import { useWizard } from "react-use-wizard";

const StepButtons = ({
    back = true,
    next = true,
    backText = "INDIETRO",
    nextText = "AVANTI",
    nextDisabled = false,
    nextHandler=null
}) => {

    const { previousStep, nextStep } = useWizard();

    const onClickNext=async()=>{
        let next=true;
        if(nextHandler){
            next =await nextHandler();
        }
        if(next) nextStep();
    }
    return <div className="step-commands">
        {back && <Button variant="outlined" style={{ flexGrow: 1 }} onClick={previousStep}>{backText}</Button>}
        {next && <Button variant="outlined" style={{ flexGrow: 1 }} onClick={onClickNext} disabled={nextDisabled}>{nextText}</Button>}
    </div>
}


export default StepButtons;